import React, { useContext, useState, useEffect } from 'react';
import './right-modal.scss';

const RightModal = ({ openSliderModal,  setOpenSliderModal, children}) => {
let activeClass =  openSliderModal ? 'active' : '';

  return (
    <div
      className={
        openSliderModal
          ? [activeClass, ' metrics_details_backdrop', 'metrics-details-backdrop'].join(' ')
          : ['metrics_details_backdrop ', 'metrics-details-backdrop'].join('')
      }
    >
      <div className={['metrics_details_div', 'metrics-details-div'].join(' ')}>
        {children}
      </div>        
    </div>
  );
};

export default RightModal;
